import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface ServiceIdeaProjectsProps {
    customService: any
}

const ServiceIdeaProjects: FC<ServiceIdeaProjectsProps> = ({ customService }) => {
    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3
            }
        }
    }

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    }

    const stepVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.5 }
        }
    }

    return (
        <motion.div
            className='flex flex-col gap-12 pt-12 bg-darkGreyPrimary'
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={containerVariants}
        >
            {customService.ServiceIdeaProjectsData.map((projects: any, index: number) => {
                let img = getImage(projects.image ?? "") ?? "";
                return (
                    <motion.div
                        key={index}
                        className='bg-darkGreyPrimary py-6 md:py-12 border-y-2 border-[#313131]'
                        variants={itemVariants}
                    >
                        <div className={classNames(
    `flex flex-col px-4 md:px-20 2xl:px-40 md:gap-20 xl:gap-40 2xl:gap-16 min-h-0 md:h-96`,
    `md:flex-${projects.row}`
)}>
    
    {/* Steps div — second on mobile, original order on desktop */}
    <div className='order-last md:order-none w-full md:w-2/5 h-auto flex flex-col gap-4 justify-between mb-8 md:mb-0'>
        {projects.steps.map((proj: any, stepIndex: number) => (
            <motion.div
                key={stepIndex}
                className={`bg-${projects.textColor} rounded-[_1.8rem_2rem_2rem_1.8rem] p-[0px] pl-[2px]`}
                variants={stepVariants}
                whileHover={{ scale: 1.01, background: '#313131' }}
                transition={{ type: 'spring', stiffness: 100 }}
            >
                <div className='bg-blackDark p-4 md:p-6 rounded-3xl font-bold text-lg md:text-xl relative overflow-hidden'>
                    {proj.title}
                </div>
            </motion.div>
        ))}
    </div>

    {/* Image div — first on mobile, original order on desktop */}
    <motion.div
        className={classNames(
            'order-first md:order-none flex flex-col w-full md:w-2/4 justify-center md:justify-end mb-5 md:mb-0 gap-2',
            `items-center md:items-${projects.justify}`
        )}
        variants={itemVariants}
    >
        <DynamicSVG color='#fff' size='w-full max-w-[250px]'>{img}</DynamicSVG>
        <motion.div
            className={classNames('font-semibold text-2xl md:text-4xl', `text-${projects.textColor}`)}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
        >
            Step {projects.key}.
        </motion.div>
        <motion.div
            className={classNames('font-semibold text-xl md:text-3xl text-white text-center md:text-left',
            `md:text-${projects.justify}`
             )}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
        >
            {projects.title}
        </motion.div>
        <motion.div
            className={classNames(
                'text-greyQuaternary text-base md:text-lg text-center md:text-left',
                `md:text-${projects.justify}`
            )}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
        >
            {projects.subtitle}
        </motion.div>
    </motion.div>

</div>
                    </motion.div>
                )
            })}
        </motion.div>
    )
}

export default ServiceIdeaProjects
